module.exports = __webpack_public_path__ + "img/Bodice-Front-B1-Da-Eb.623be28a.png";